import { AuroraContainer } from './Container.styled';
import { SIZE, VARIANT, SHADOW } from './constants';
import type { AuroraContainerProps } from './types';

export const Container = ({
  children,
  hasBorder = true,
  size = 'large',
  variant = 'primary',
  shadow = 'none',
  ...props
}: AuroraContainerProps) => {
  const isBordered = hasBorder ? 'bordered' : 'borderless';

  const style = {
    backgroundColor: VARIANT[variant as keyof typeof VARIANT],
    boxShadow: SHADOW[shadow as keyof typeof SHADOW],
    padding: SIZE[size as keyof typeof SIZE],
  };

  return (
    <AuroraContainer
      data-bordered={isBordered}
      data-size={size}
      data-test="aurora-container"
      style={style}
      {...props}
    >
      {children}
    </AuroraContainer>
  );
};
